module.exports = __webpack_public_path__ + "static/media/Mobile_Blockchain.f99a1b3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Curso_img/splint/Mobile_Blockchain.png
// module id = 49
// module chunks = 0